var map = {
	"./f1/en/deposit_sample_2x.png": 7588,
	"./f1/th/deposit_sample_2x.png": 3085,
	"./f1/vn/deposit_sample_2x.png": 8033,
	"./f1/zh/deposit_sample_2x.png": 4495,
	"./j1/th/deposit_sample_2x.png": 3169,
	"./j1/vn/deposit_sample_2x.png": 9437,
	"./j1/zh/deposit_sample_2x.png": 939,
	"./p1/th/deposit_sample_2x.png": 9771,
	"./p1/vn/deposit_sample_2x.png": 2863,
	"./p1/zh/deposit_sample_2x.png": 4641
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2522;